import { memo, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames/bind';

import tabs, { LATEST, AWARDS, VIDEOS } from '../../data/press/tabs';

import Preloader from '../Preloader';

import { getPressArticles } from '../../actions/press.actions';
import withMetatag from '../../decorators/metadataDecorators/metatagsTitleDecorator';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const Press = () => {
  const dispatch = useDispatch();
  const { articles, loading, user } = useSelector(({ press, userPreferencesReducer }) => ({
    articles: press.articles,
    loading: press.loading,
    user: userPreferencesReducer.user,
  }));
  const [activeTab, setActiveTab] = useState(AWARDS);

  const isCurator = Boolean(user?.is_curator);

  useEffect(() => {
    if (!articles) {
      dispatch(getPressArticles({ preview: isCurator }));
    }
  }, [articles, dispatch, isCurator]);

  return (
    <main className={Styles['press-page-wrapper']}>
      <Preloader loading={loading} />
      {Boolean(articles) && (
        <>
          <div className={Styles['mobile-buttons-press']}>
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={cx({ active: activeTab === tab.id })}
                onClick={() => setActiveTab(tab.id)}
                type="button"
              >
                {tab.content}
              </button>
            ))}
          </div>
          <div className={Styles['press-page-content']}>
            <div className={Styles['press-page-latest-news']} style={activeTab === LATEST ? { display: 'block' } : null}>
              <h1 className={Styles['press-page-title']}>Latest News</h1>
              <ul className={Styles['latest-news-list']}>
                {articles.latestNews.map((article) => (
                  <li key={article.id}>
                    <img
                      style={{ top: '3px' }}
                      src={article.logo}
                      alt=""
                      loading="lazy"
                    />
                    <span className={Styles['latest-news-date']}>
                      {article.date}
                    </span>
                    <h3>
                      <a href={article.link} target="_blank" rel="noreferrer noopener">
                        {article.title}
                      </a>
                    </h3>
                    <p className={Styles['latest-news-text']}>
                      {article.text}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
            <div className={Styles['press-page-grid']} style={activeTab === AWARDS ? { display: 'block' } : null}>
              <h1 className={Styles['press-page-title']}>Awards and Recognition</h1>
              <div className={Styles['press-page-grid-tiles']}>
                {articles.awards.map((article) => (
                  <section key={article.id} className={Styles['news-tile']}>
                    <img
                      className={Styles['news-tile-logo']}
                      src={article.logo}
                      alt=""
                      loading="lazy"
                    />
                    <span className={Styles['news-tile-date']}>
                      {article.date}
                    </span>
                    <h2>
                      <a href={article.link} target="_blank" rel="noreferrer noopener">
                        {article.title}
                      </a>
                    </h2>
                    <p className={Styles['news-tile-text']}>
                      {article.text}
                    </p>
                    <img
                      src={article.image}
                      alt=""
                      loading="lazy"
                    />
                  </section>
                ))}
              </div>
            </div>
            <div className={Styles['press-page-videos']} style={activeTab === VIDEOS ? { display: 'block' } : null}>
              <h1 className={Styles['press-page-title']}>Videos</h1>
              {articles.videos.map((article) => (
                <div key={article.id} className={Styles['press-page-video']}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: article.embedded_code,
                    }}
                  />
                  <h3>
                    <a href={article.link} target="_blank" rel="noreferrer noopener">
                      {article.title}
                    </a>
                  </h3>
                  <p>
                    {article.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </main>
  );
};

export default memo(withMetatag(Press, 'press'));
